// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"2eb74170","112":"f6430c81","313":"2879d8c9","462":"51f11582","521":"b0b511dd","540":"8ebe96e7","586":"91ecee15","688":"f5d3fce2","705":"6c0bf7f5","734":"94d706ff","881":"fc310ced","978":"ad2c1c20","989":"64b74dab"}[chunkId] + ".chunk.js";
};